import request from '../utils/request'
export const listClasses = params => request.get('/classes', { params })
export const createClass = data => request.post('/classes', data)
export const updateClass = (id, data) => request.patch(`/classes/${id}`, data)
export const deleteClass = id => request.delete(`/classes/${id}`)
export const getClassStudents = (id, params) => request.get(`/classes/${id}/students`, { params })
